import { createFileRoute } from "@tanstack/react-router";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";
import { CvSendsTable } from "./-pages/cv-sends-table";

export const Route = createFileRoute("/_dashboard/$datasetSlug/data/cv-sends/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { datasetSlug } = Route.useParams();
  useBreadCrumbs([{ title: "CV Sends", link: `/${datasetSlug}/data/cv-sends` }]);
  return <CvSendsTable />;
}
